import { createActions, handleActions } from 'redux-actions';

const defaultState = {
  loadingProgress: false,
  title: '',
};

const _actions = createActions({
  app: {
    setTitle: payload => payload,
    loadingOn: payload => payload,
    loadingOff: payload => payload
  }
});
const actions = _actions.app;

const setTitle = (state, action) => {
  return Object.assign({}, state, { title: action.payload });
};

const loadingOn = (state, action) => {
  return Object.assign({}, state, { loadingProgress: true });
};
const loadingOff = (state, action) => {
  return Object.assign({}, state, { loadingProgress: false });
};

const reducer = handleActions(
  {
    [actions.setTitle]: setTitle,
    [actions.loadingOn]: loadingOn,
    [actions.loadingOff]: loadingOff
  },
  defaultState
);

export { actions, reducer };
